var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    stroke: "white",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6436 14.6467H8.9445C8.29515 14.6467 7.76465 14.1162 7.76465 13.4669V8.76774C7.76465 8.11839 8.29515 7.58789 8.9445 7.58789H13.6436C14.293 7.58789 14.8235 8.11839 14.8235 8.76774V13.4669C14.8235 14.1191 14.2959 14.6467 13.6436 14.6467Z",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0141 12.4003C10.3562 12.7423 10.8113 12.9308 11.2955 12.9308C11.7796 12.9308 12.2318 12.7423 12.5768 12.4003C12.9188 12.0582 13.1073 11.6031 13.1073 11.1189C13.1073 10.6348 12.9188 10.1797 12.5768 9.83763C12.2347 9.49556 11.7796 9.30713 11.2955 9.30713C10.8113 9.30713 10.3562 9.49556 10.0141 9.83763C9.67207 10.1797 9.48364 10.6348 9.48364 11.1189C9.48364 11.6031 9.67207 12.0582 10.0141 12.4003Z",
    stroke: "white",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4604 9.24751C13.6526 9.24751 13.8083 9.09176 13.8083 8.89963C13.8083 8.70751 13.6526 8.55176 13.4604 8.55176C13.2683 8.55176 13.1125 8.70751 13.1125 8.89963C13.1125 9.09176 13.2683 9.24751 13.4604 9.24751Z",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.069a0d67f32b3926b30bf657ddc64fe2.svg";
export { ForwardRef as ReactComponent };